
<template>
  <OsTabGuide
    :ios-images="getLabel('ios')"
    :android-images="getLabel('android')"
  />
</template>
<script setup lang="ts">
const { query } = useRoute()
const { step, direct, code } = query

// 페이지별 이미지 라벨 정의
const guideImageLabel: OsGuideImageLabel = {
  ios: {
    step: {
      integrated: ['img-guide-ios-0', 'img-guide-ios-1-v2', 'img-guide-ios-2-v2', 'img-guide-ios-3', 'img-guide-ios-4'], // guide/domestic 경로에서 보여주는 이미지들
      install: {
        direct: {
          qr: ['img-guide-ios-1-v2', 'img-guide-ios-3'], // guide/domestic?step=install&direct=true&code=qr
          activation: ['img-guide-ios-2-v2', 'img-guide-ios-3'] // guide/domestic?step=install&direct=true&code=activate
        },
        manual: {
          qr: ['img-guide-ios-2-1-v2', 'img-guide-ios-3'], // guide/domestic?step=install&direct=false&code=qr
          activation: ['img-guide-ios-2-v2', 'img-guide-ios-3'] // guide/domestic?step=install&direct=false&code=activate
        }
      },
      activate: ['img-guide-ios-4'] // guide/domestic?step=activate
    }
  },
  android: {
    step: {
      integrated: ['img-guide-aos-0', 'img-guide-aos-1', 'img-guide-aos-2', 'img-guide-aos-3'], // guide/domestic 경로에서 보여주는 이미지들
      install: {
        direct: {
          qr: ['img-guide-aos-1'], // guide/domestic?step=install&direct=true&code=qr
          activation: ['img-guide-aos-2'] // guide/domestic?step=install&direct=true&code=activation
        },
        manual: {
          qr: ['img-guide-aos-1'], // guide/domestic?step=install&direct=false&code=qr
          activation: ['img-guide-aos-2'] // guide/domestic?step=install&direct=false&code=activation
        }
      },
      activate: ['img-guide-aos-3'] // guide/domestic?step=activate
    }
  }
}

const getLabel = (os: 'ios'|'android') => {
  if (!step) {
    return guideImageLabel[os].step.integrated
  }
  if (step === 'install') {
    const method = direct === 'true' ? 'direct' : 'manual'
    if (code) {
      return (guideImageLabel[os].step.install[method] as { [key: string]: string[] })[code.toString()]
    }
  } else if (step === 'activate') {
    return guideImageLabel[os].step.activate
  }
  return []
}

</script>
